import { render, staticRenderFns } from "./Enterprise-addfication.vue?vue&type=template&id=36b52799&scoped=true&"
import script from "./Enterprise-addfication.vue?vue&type=script&lang=js&"
export * from "./Enterprise-addfication.vue?vue&type=script&lang=js&"
import style0 from "./Enterprise-addfication.vue?vue&type=style&index=0&id=36b52799&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b52799",
  null
  
)

export default component.exports